import {useParams} from 'react-router-dom'
import {Input} from 'antd'

import styles from './BorrowerProjectFeedback.module.scss'
import {Button, Modal, Form, FormItem, Loader, Text} from 'common/components'
import {useOpen} from 'common/hooks'
import {formatDate} from 'common/helpers'
import {FIELD_RULES} from 'common/constants'
import {useGetProjectFeedback, useCreateProjectFeedback} from '..'

interface FeedbackFormProps {
  projectUuid: string
  onClose: () => void
}

export default function BorrowerProjectFeedback() {
  const params = useParams()
  const {data: feedback} = useGetProjectFeedback(params.uuid)
  const [isOpen, handleOpen, handleClose] = useOpen()

  if (!feedback) return <Loader />

  const hasFeedback = Boolean(feedback.length)

  return (
    <>
      <div className={styles.root}>
        {hasFeedback && (
          <ul>
            {feedback.map((item, index) => (
              <li key={index} className={styles.item}>
                <Text color="grey" size="xs" mb={8}>
                  {formatDate(item.createdAt)}
                </Text>
                <p>{item.text}</p>
              </li>
            ))}
          </ul>
        )}
        <Button variant="secondary" onClick={handleOpen}>
          leave{hasFeedback ? ' another' : ''} feedback
        </Button>
      </div>
      <Modal width={486} title="Feedback" open={isOpen} onCancel={handleClose}>
        <FeedbackForm projectUuid={params.uuid} onClose={handleClose} />
      </Modal>
    </>
  )
}

const FeedbackForm = ({projectUuid, onClose}: FeedbackFormProps) => {
  const {mutate: createProjectFeedback, isMutating} = useCreateProjectFeedback(
    projectUuid,
    onClose
  )

  const handleFinish = (values: any) => createProjectFeedback(values)

  return (
    <Form onFinish={handleFinish}>
      <FormItem name="text" label="Feedback" rules={FIELD_RULES}>
        <TextArea autoFocus rows={5} />
      </FormItem>
      <Button block htmlType="submit" loading={isMutating}>
        Save feedback
      </Button>
    </Form>
  )
}

const {TextArea} = Input
